export function normalizeAddress(address: string | undefined): string | undefined {
    if (!address || address.trim().length === 0) return undefined;
    return address
        .replace(/\s+/g, ' ')
        .replace(/[^\w\s,#-]/gi, '')
        .trim()
        .toLowerCase();
}
